import React from "react";
import { SupText, SupChip } from "@repo/core-ui";

import { SupTxChain } from "../../TxChain";
import type { VaultProps } from "../../types";

export function VaultValue({ vaultName, vaultUrl, protocolLogo, protocolName, protocolUrl, chainLogo, chainName, chainUrl }: VaultProps) {
  return (
    <SupText as="div" variant="subtitle1" className="inline-flex items-center gap-2 whitespace-nowrap">
      <a href={vaultUrl} target="_blank" rel="noreferrer">
        {vaultName}
      </a>
      {protocolName && (
        <a href={protocolUrl} target="_blank" rel="noreferrer">
          <SupChip icon={protocolLogo} label={protocolName} type="rounded" border borderStyle="dashed" />
        </a>
      )}
      <span>ON</span>
      <SupTxChain chainLogo={chainLogo} chainName={chainName} explorerUrl={chainUrl} />
    </SupText>
  );
}
